import React from 'react';
import { twMerge } from 'tailwind-merge';
import MenuVariant from './MenuVariant';
const menuClass = (variant) => {
    const classes = ['text-gray-900'];
    if (variant === MenuVariant.Hover) {
        classes.push('hover:bg-gray-100', 'px-4', 'py-1', 'font-normal');
    }
    else if (variant === MenuVariant.Underline) {
        classes.push('text-sm', 'font-bold', 'hover:underline focus:underline');
    }
    return classes;
};
const UserAccountMenu = ({ menuList, variant, }) => {
    const menuItems = Object.values(menuList).map((menu, index) => (<a key={index} data-cy={menu.title} className={twMerge('account-menuItem no-underline', ...menuClass(variant), 'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white')} href={menu.url} target={menu.target || ''} onClick={() => deleteFoldersLocalStorage(menu.title)}>
      {menu.title}
    </a>));
    function deleteFoldersLocalStorage(title) {
        if (title === 'Logout') {
            localStorage.removeItem('folders');
        }
    }
    return variant === MenuVariant.Underline ? (<div className="flex flex-col items-center px-4 pt-4 space-y-4">
      {menuItems}
    </div>) : (<>{menuItems}</>);
};
export default UserAccountMenu;
